import { render, staticRenderFns } from "./CartBottomSheet.vue?vue&type=template&id=63d85587&scoped=true&"
import script from "./CartBottomSheet.vue?vue&type=script&lang=ts&"
export * from "./CartBottomSheet.vue?vue&type=script&lang=ts&"
import style0 from "./CartBottomSheet.vue?vue&type=style&index=0&id=63d85587&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d85587",
  null
  
)

export default component.exports